<template>
  <div :class="card?'tabsCard':''">
    <div :class="'tabs '+(mini?'mini':'')">
      <div
        :class="'tab '+(isInvalid(item.value)?'font13 unselected':
      (item.value==selected?'font6 selected cursor':'font4 unselected cursor'))"
        :style="'font-size:'+textSize+';'"
        v-for="item in data"
        :key="item.value"
        @click="!isInvalid(item.value)?click(item.value):''"
      >{{item.label}}</div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    isInvalid(value) {
      return this.invalid.includes(value);
    },
    click(value) {
      if (value != this.selected) {
        this.$emit("update:selected", value);
        this.$emit("change");
      }
    }
  },
  props: {
    mini: {
      type: Boolean,
      default: () => false
    },
    data: {
      type: Array,
      default: () => []
    },
    selected: {
      type: String,
      default: () => ""
    },
    invalid: {
      type: Array,
      default: () => []
    },
    card: {
      type: Boolean,
      default: () => false
    },
    textSize: {
      type: String,
      default: () => "16px"
    }
  }
};
</script>

<style scoped>
.tabs {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.tab {
  padding: 12px 16px;
}

.selected {
  border-bottom-width: 2px;
  border-bottom-style: solid;
  border-color: #1890ff;
}

.unselected {
  padding-bottom: 14px;
}

.mini {
  justify-content: flex-start;
}

.mini .tab:nth-child(n + 2) {
  margin-left: 32px;
}

.tabsCard {
  border: 1px solid #e9e9e9;
}

.tabsCard > div:nth-child(1) {
  padding-left: 24px;
  border-bottom: 1px solid #e9e9e9;
}
</style>


// WEBPACK FOOTER //
// src/views/components/Tabs.vue